import { Link } from "react-router-dom";
import React, { Component } from "react";
import { modquizPaths } from "../../index";

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import "./style.css";
import { SubjectListItemMenu } from "./Menu";

class SubjectListItem extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            imageErrored: false
        };
        this.publicPrivate = this.publicPrivate.bind(this);
        this.onError = this.onError.bind(this);
    }

    publicPrivate() {
        if (this.props.public) {
            return <div>Public</div>;
        }
        return <div>Private</div>;
    }

    onError() {
        if (!this.state.imageErrored) {
            this.setState({
                imageErrored: true
            });
        }
    }

    render() {
        let showPublic = <div></div>;
        if (this.props.showPublic) {
            showPublic = <span>• {this.publicPrivate()}</span>;
        }

        var props = this.props;

        let objectCount = 0;
        if (props.quizObjectCount) {
            objectCount = props.quizObjectCount.toString();
        }

        return (
            <TableRow className={"row subject-index-list-item"}>
                <TableCell className="col-1 image">
                    {props.image_url && !this.state.imageErrored ? (
                        <img
                            src={props.image_url}
                            alt={`Image for ${props.title}`}
                            onError={this.onError}
                        />
                    ) : null}
                </TableCell>
                <TableCell className="text-col col-3">
                    <Link to={modquizPaths.subject(props.hash_key)}>
                            {" "}
                        <b className="title-slug">{props.title}</b>
                        <div className="title-user">{props.user}</div>
                    </Link>
                </TableCell>
                <TableCell className="text-col col-5">{props.description}</TableCell>
                <TableCell className="text-col col-1">
                    <div>
                        <b>{objectCount}</b>
                    </div>
                </TableCell>
                <TableCell className="text-col col-1">{showPublic}</TableCell>
                <TableCell className="text-col col-1">
                    <SubjectListItemMenu subjectHashKey={props.hash_key} mark_complete={this.props.markComplete} />
                </TableCell>
            </TableRow>
        );
    }
}

export default SubjectListItem;
